module.exports = __webpack_public_path__ + "img/collection-engagementRings070Carat.aa89f1d.jpg";